<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <form action="/">
      <van-search
        v-model="search.key"
        class="serBar"
        placeholder="请输入搜索关键词"
        background="#F1F1F1"
        show-action
        @search="onSerSearch"
        @clear="onSerCancel"
      >
        <div slot="action" @click="changeType">{{ isListModel?"地图":"列表" }}</div>
      </van-search>
    </form>
    <baidu-map center="北京" @ready="mapHandlersearch" />
    <div class="serType">
      <van-dropdown-menu active-color="#E32119">
        <van-dropdown-item v-model="search.country" :options="option_country" @open="countryOpen" @close="countryClose" />
        <van-dropdown-item v-model="search.course" :options="option_course" @change="selectTypeClose" />
        <van-dropdown-item v-model="search.offers" :options="option_offers" @change="selectTypeClose" />
        <!-- <van-dropdown-item ref="item" title="筛选"> -->
        <!-- <van-switch-cell v-model="switch1" title="包邮" />
          <van-switch-cell v-model="switch2" title="团购" />
          <van-button block type="info" @click="onConfirm">确认</van-button>
        </van-dropdown-item>-->
      </van-dropdown-menu>
    </div>
    <van-list
      v-if="isListModel"
      v-model="loading"
      class="listBody"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.diveCenterId" class="shopRect" @click="onSelect(item)">
        <img class="icon" :src="item.icon">
        <div class="body">
          <div class="supportLine pagebody3">
            {{ item.supportChinese?'支持中文':'' }}
          </div>
          <div class="pageTitle1 title">{{ item.title }}</div>
          <div class="pagebody3 aboutStr">{{ item.about }}</div>
          <div class="pagebody2 address">{{ getCountryText(item.country) }} {{ item.city }}  </div>
          <div v-if="item.distance" class="pagebody2 address">{{ Math.ceil(item.distance) }}公里</div>
        </div>
      </div>
    </van-list>
    <baidu-map v-if="!isListModel" class="mapRect" center="中国" :scroll-wheel-zoom="true" @load="MapLoad" @ready="Maphandler" @movestart="Mapmovestart" @moveend="Mapmoveend">
      <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
      <bml-marker-clusterer :average-center="true" :max-zoom="11">
        <bm-marker v-for="item of mapPointList" :key="item.diveCenterId" :position="{lng: item.lng, lat: item.lat}" @click="mapPointSelect(item.diveCenterId)" />
      </bml-marker-clusterer>
      <!-- <bm-point-collection :points="mapPointList" shape="BMAP_POINT_SHAPE_STAR" color="red" size="BMAP_POINT_SIZE_SMALL" @click="clickHandler" /> -->
    </baidu-map>

  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, getCountryText, baiduLevelMetre } from '@/utils/base'
import { Button, Search, DropdownMenu, DropdownItem, List } from 'vant'
import commonData from '@/commondata.js'
import { BmlMarkerClusterer } from 'vue-baidu-map'
export default {
  name: 'GlobaldivecenterList',
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    TopBar,
    BmlMarkerClusterer
  },
  data() {
    return {
      offsetTop: 0,
      title: '全球潜水中心',
      backurl: '/store/index',
      isListModel: true,
      isFinishLocation: false, // 获取坐标完成
      search: {
        lat: 43.8344,
        lng: 18.34301,
        key: undefined,
        country: '',
        course: '',
        offers: '',
        language: undefined,
        gas: undefined,
        rental: undefined,
        service: undefined,
        other: undefined,
        page: 1,
        limit: 40
      },
      mapisFirst: true, // 地图第一次使用
      mapObject: undefined, // 地图对象
      timeMapReload: undefined, // 定时刷新对象
      mapMoveStarPoing: undefined, // 记录移动起点坐标对象
      mapPointList: [], // 地图渲染列表
      mapPointDataList: [], // 地图数据列表
      option_country: [
      ],
      option_course: [
        { text: '全部课程', value: '' },
        { text: '水肺潜水', value: 'scuba' },
        { text: '技术潜水', value: 'xr' },
        { text: '循环呼吸', value: 'rebreather' },
        { text: '自由潜', value: 'freediving' },
        { text: '浮潜', value: 'sno' },
        { text: '游泳', value: 'swim' },
        { text: '美人鱼', value: 'mermaid' },
        { text: '救生员', value: 'lifeguard' },
        { text: '紧急救援', value: 'emergency' },
        { text: '适应性潜水', value: 'classified' },
        { text: '生态', value: 'ecology' }

      ],
      option_offers: [
        { text: '全部类型', value: '' },
        { text: '岸潜', value: 'dives_shore' },
        { text: '泳池', value: 'pool_dives' },
        { text: '船潜', value: 'boat_dives' },
        { text: '浮潜', value: 'snorkel_tours' },
        { text: '沉船', value: 'dives_wreck' },
        { text: '适应性潜水1', value: 'handicapped_diving' },
        { text: '技术潜', value: 'divers_xr' },
        { text: '适应性潜水2', value: 'dives_classified' },
        { text: '自由潜', value: 'dives_freediving' }
      ],
      list: [],
      loading: false,
      finished: false
    }
  },
  activated() {
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    // keep-alive组件 页面进入的时候设置滚动高度
    console.log('activated', this.offsetTop)
    document.documentElement.scrollTop = this.offsetTop
    // 移动一下地图以免点消失
    if (this.isListModel) {
      console.log('我退回到地图页面了')
      if (this.mapObject !== undefined) {
        var selfs = this
        window.setTimeout(function() {
          selfs.mapObject.panBy(1, 0)
        }, 100)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  created() {
    initPage(false)

    this.list = []
    // this.onLoad()
    // 读取下拉搜索框
    this.option_country = [{ text: '全部国家', value: '' }]
    var countryList = commonData.ssiBase.COUNTRIES
    countryList.forEach(item => {
      this.option_country.push({
        text: item.iso3,
        text1: item.country,
        value: item.iso3
      })
    })
  },
  methods: {
    getCountryText,
    mapHandlersearch({ BMap, map }) {
      console.log('Get {BMap, map}', map)
      var geolocation = new BMap.Geolocation()
      var selfs = this
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() === 0) {
          selfs.search.lat = r.point.lat
          selfs.search.lng = r.point.lng
          // alert('您的位置：' + r.point.lng + ',' + r.point.lat)
        } else {
          selfs.search.lat = undefined
          selfs.search.lng = undefined
          // alert('failed' + this.getStatus())
        }
        selfs.onLoad(true)
      }, { enableHighAccuracy: true })
    },
    Maphandler({ BMap, map }) {
      console.log('初始化地图成功', map)
      this.mapObject = map
    },
    MapLoad() {
      this.mapMoveStarPoing = this.mapObject.getCenter()
      console.log('初始化位置', this.mapMoveStarPoing)
    },
    mapPointSelect(diveCenterId) {
      console.log('选择了潜水中心', diveCenterId)
      this.$router.replace('/store/globaldivecenter/' + diveCenterId)
    },
    Mapmovestart(e) {
      this.mapMoveStarPoing = e.target.getCenter()
      console.log('Mapmovestart', this.mapMoveStarPoing)
    },
    Mapmoveend(e) {
      console.log('Mapmoveend', e.target.getCenter())
      var jl = this.mapObject.getDistance(this.mapMoveStarPoing, e.target.getCenter())
      var movelMetre = baiduLevelMetre(e.target.getZoom()) * 0.5
      if (jl > movelMetre) {
        console.log('reload')
        this.mapMoveStarPoing = e.target.getCenter()
        if (this.timeMapReload !== undefined) {
          window.clearTimeout(this.timeMapReload)
        }
        this.timeMapReload = window.setTimeout(this.reloadMapPoint, 1000)
      }
    },
    reloadMapPoint() {
      if (this.mapObject === undefined || this.mapMoveStarPoing === undefined) {
        console.log('地图对象尚未成功初始化，等待中')
        this.timeMapReload = window.setTimeout(this.reloadMapPoint, 200)
        return
      }
      console.log('真实开始重新加载数据', this.mapMoveStarPoing)

      this.mapPointDataList.forEach(item => {
        item.distance = this.mapObject.getDistance(this.mapMoveStarPoing, { lng: item.lng, lat: item.lat })
      })
      this.mapPointDataList.sort((a, b) => a.distance - b.distance)
      console.log('排序后的数组', this.mapPointDataList)
      this.mapPointList = []
      for (var i = 0; i < 100; i++) {
        if (this.mapPointDataList[i] === undefined) {
          break
        }
        this.mapPointList.push(this.mapPointDataList[i])
      }
      console.log(this.mapPointList)
      this.timeMapReload = undefined
      if (this.mapisFirst) {
        this.mapObject.panBy(1, 0)
        this.mapisFirst = false
      }
    },
    changeType() {
      this.isListModel = !this.isListModel
      if (!this.isListModel) {
        this.loadMapData()
      } else {
        this.list = []
        this.search.page = 1
        this.onLoad()
      }
    },
    loadMapData() {
      request({
        url: '/Store/getDiveCenterPointList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        console.log('Map Model response', response)
        this.mapPointDataList = response.data
        if (this.timeMapReload !== undefined) {
          window.clearTimeout(this.timeMapReload)
        }
        this.timeMapReload = window.setTimeout(this.reloadMapPoint, 200)
      })
    },
    countryOpen() {
      this.option_country.forEach(item => {
        if (item.value !== '') {
          item.text = item.text1
        }
      })
    },
    countryClose() {
      this.option_country.forEach(item => {
        if (item.value !== '') {
          item.text = item.value
        }
      })
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    selectTypeClose() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onSerSearch() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onSerCancel() {
      this.search.key = ''
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onSelect(item) {
      this.$router.replace('/store/globaldivecenter/' + item.diveCenterId)
    },
    onLoad(isFirst) {
      // 如果不是列表模式则执行地图模式逻辑
      if (!this.isListModel) {
        this.loadMapData()
        return
      }
      if (isFirst === undefined && !this.isFinishLocation) {
        return
      }

      this.loading = true
      request({
        url: '/Store/getDiveCenterList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (isFirst) {
          this.isFinishLocation = true
        }
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.van-search__content{
    background-color: #fff ;
}
.van-dropdown-menu{
    border-top-left-radius:1em;
    border-top-right-radius:1em;
}
.serBar{
    position: fixed;
    left: 0;
    top:3em;
    width: 100%;
    height: 3.5em;
    z-index: 10;
}
.serType{
    background-color: #f1f1f1;
    position: fixed;
    left: 0;
    top:6.5em;
    height: 3em;
    width: 100%;
    z-index: 10;
}
.van-dropdown-menu{
    height: 3em;
}
.listBody{
    margin-top: 7em;
}
.mapRect{
  border-top: 1px solid #cacaca;
  position: fixed;
  left: 0;
  right: 0;
  top:9.5em;
  bottom: 0;
}
.shopRect{
    height: 7.5em;
    border-bottom: 1px solid #f1f1f1;
    margin: 0.5em 1em;
    position: relative;
}
.shopRect .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding-right: 3em;
    height: 2.6em;
}
.shopRect .aboutStr{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    height: 1.8em;
    line-height: 1.8em;
}
.shopRect .address{
    margin-top: 0.6em;
    height: 0.8em;
}
.shopRect .supportLine
{
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    border-top:1px solid #E32119;
    border-bottom:1px solid #E32119;
    color: #E32119;
    font-weight: 700;
}
.shopRect .icon{
    height: 6.8em;
    width: 6.8em;
    padding: 0.1em;
}
.shopRect .body{
    position: absolute;
    left:7em;
    top:0;
    width: calc(100% - 8em);
    padding: 0.5em;
}

</style>
